import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { CallHangupCause } from './call-hangup-cause.enum';
import { ConversationDirection } from './conversation-direction.enum';
import { ConversationSegmentDto } from './conversation-segment.dto';
import { ConversationTransferType } from './conversation-transfer-type.enum';

@Api('api/agentic-cx/conversation')
export class ConversationDto extends DtoHasApi {
  id!: number;
  typeId!: ConversationDirection;
  creationTime!: string;
  startTime!: string;
  endTime!: string | null;
  duration!: number | null;
  callerNumber!: string;
  calledNumber!: string;
  isDeleted!: boolean;
  tenantId!: string | null;
  contactId!: number | null;
  conversationUid!: string | null;
  segments!: ConversationSegmentDto[];
  hangupCause?: CallHangupCause;
  contactName!: string | null;
  agentName!: string | null;
  campaignId!: number | null;
  campaignName!: string | null;
  isAiOnly!: boolean;
  segmentCount!: number;
  queueIds!: string | null;
  queueNames!: string[];
  agentId!: string | null;
  callerAgentId!: string | null;

  /**
   * Wrap-up code the conversation was closed with, taken from the segment that ended the call.
   * Null when it was closed without one. Display only — not sortable or filterable.
   */
  wrapUpId!: number | null;
  wrapUpName!: string | null;

  /**
   * How this conversation was handed over, derived server-side from its segments. Empty when it
   * involved no transfer; several values when it contained more than one kind of hand-over.
   */
  transferTypes!: ConversationTransferType[] | null;

  /** Conversation whose callback this conversation fulfilled; list queries only (K-078). */
  scheduledCallOfConversationId?: number | null;

  /** Callback conversations born from this one, oldest first; list queries only (K-078). */
  scheduledCallsToConversationIds?: number[];
}
